import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

export function getLiaisonsGlobal(): Promise<ApiResponse> {
  return Axios.get(`v1/liaisons/statistics/global`);
}
